export default {
  BASE_URL: 'https://www.kona-shuttle.com/crm_beta/index.cfm',
  flights: {
    oneWay: '1',
    roundTrip: '2',
  },
  operator: {
    plus: 'plus',
    minus: 'minus',
  },
  MEAL: {
    MAIN: 'choice of entrée',
    DESSERT: 'choice of dessert',
    APPETIZER: 'choice of appetizer',
  },
  REQUEST: {
    FLIGHTS: 'SelectedFlights',
    PASSENGERS: 'getPassengers',
    SEATS: 'selectSeats',
    MEALS: 'selectMeals',
    REVIEW: 'reviewRes',
    ACTION: { PRINT: 'PrintReservation' },
  },
  DATE_FORMAT: 'MM/DD/YYYY',
  TIME_FORMAT: 'hh:mm',
  SERVER_DATE_FORMAT: 'YYYY-MM-DD',
  DEFAULT_EXIT_ROW: 8,
};



// WEBPACK FOOTER //
// ./src/model/AppConfiguration.js